import { ReactSVG } from 'react-svg'

import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

interface DeleteProductProps {
  className?: string;
  onClick?: () => void;
}

export default function DeleteProduct (props: DeleteProductProps) {
  const { className, onClick } = props

  return (
    <Button
      className={cn(styles.root, className)}
      theme="grey"
      onClick={onClick}
    >
      <ReactSVG src="/icons/trash.svg" wrapper="span" />
    </Button>
  )
}
